import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

export const THEMES = {
  military: {
    id: "military",
    name: "Tactical HUD",
    tagline: "OLIVE / STEEL",
  },
  neon: {
    id: "neon",
    name: "Cyber Neon",
    tagline: "CYAN / MAGENTA",
  },
};

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(() => {
    if (typeof window === "undefined") return "military";
    return localStorage.getItem("wd.theme") || "military";
  });

  useEffect(() => {
    const el = document.documentElement;
    el.setAttribute("data-theme", themeId);
    localStorage.setItem("wd.theme", themeId);
  }, [themeId]);

  const toggle = () => setThemeId((t) => (t === "military" ? "neon" : "military"));

  return (
    <ThemeCtx.Provider value={{ themeId, theme: THEMES[themeId], setThemeId, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
};
